import { PeopleMerchantDto } from "./people-merchant.dto";
import { PeopleMerchantGroupDto } from "./people-merchant-group.dto";
import { PeopleEmployeeDto } from "./employee/people-employee.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleCostCentreDto {
    id: number;
    name: string;
    merchantGroupId: number;

    merchantGroup?: PeopleMerchantGroupDto;
    merchants?: PeopleMerchantDto[];
    employees?: PeopleEmployeeDto[];
}

export interface PeopleCostCentreQueryDto extends PeopleQueryBaseDto {
    name?: string;
    merchantGroupId?: number;
}